import React from 'react'
import FormInput from '../../../library/form/components/FormInput';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import * as fn from "../../../helper/uiFunctions";

const ProfileChargeRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    console.log("ProfileChargeRow",viewData.dataList.isEditMode, fn.compareNumber(viewData.dataList.isEditMode, 1))
    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <div id="sectioneditorContainer" >
                <ul className="uiBudgetBrkupEditLine">
                    <li className="uiColumnCenter uiColumn70">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "chargeRowId" }} style={{ width: "60px" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn200">
                        <FormInput formObject={formObject} rowKey={rowKey} autofocus className=""
                            action={{ InputType: "ac", paramName: "chargeType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn200">
                        <FormInput formObject={formObject} rowKey={rowKey} className=""
                            action={{ InputType: "ac", paramName: "chargeItem", acMethod: "ItemName1", acDepCtrl: { 'dparam': "%dataList.valLDT" } }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn150">
                        <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiColumn130"
                            action={{ InputType: "input", paramName: "charge" }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn150">
                        <FormInput formObject={formObject} rowKey={rowKey} className=""
                            action={{ InputType: "ac", paramName: "taxType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn100 uiActionBlock">
                        <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="confirm"
                            onlyIcon={true}
                            tooltip="Confirm Changes"
                            starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "save", actionParam: {}, containerKey: "row" }}
                            className="" ></FormButton>

                        <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="cancel"
                            onlyIcon={true}
                            tooltip="Cancel Changes"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "cancel", actionParam: {}, containerKey: "row" }}
                            className="" ></FormButton>
                    </li>
                </ul>
            </div>
        )
    }
    else {
        return (
            <ul >
                <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "chargeRowId" }} style={{ width: "60px" }} />
                </li>
                <li className="uiColumnCenter uiColumn200" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "chargeType" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "chargeItem" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "charge" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxType" }} />
                </li>

                <li className="uiColumnCenter uiColumn100 uiActionBlock" >
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                </li>
            </ul>
        )
    }
}

export default ProfileChargeRow